export default __webpack_public_path__ + "static/media/open_sans.057ca67c.ttf";